import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { Testimonial } from './Testimonial';
export function OfferStack() {
  const bonuses = [{
    title: 'BONUS #1: The "Quiet-House" Protocol',
    desc: '15-minute routines you can do in your pajamas. [WITH ONE-TAP VIDEO LIBRARY] — Zero noise, zero guesswork.'
  }, {
    title: 'BONUS #2: The 10-Min "Mom-Fuel" Kitchen',
    desc: 'Eat to heal, not to starve. Breastfeeding-safe and anti-inflammatory.'
  }, {
    title: 'BONUS #3: The Brain-Fog Eraser',
    desc: 'Reclaim your focus and stable mood in 2 minutes a day.'
  }, {
    title: 'BONUS #4: The "Back to Sexy" Identity Journal',
    desc: 'Rebuild your confidence and libido from the inside out.'
  }, {
    title: 'BONUS #5: The C-section Recovery Secrets',
    desc: 'Scientific scar tissue healing and lower-ab re-activation.'
  }];
  return <section className="py-12 md:py-24 px-4 bg-white" data-id="element-95">
      <div className="max-w-6xl mx-auto" data-id="element-96">
        <div className="text-center mb-10 md:mb-16" data-id="element-97">
          <p className="text-brand-sage font-bold tracking-widest uppercase text-sm mb-4" data-id="element-98">
            Introducing
          </p>
          <h2 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-99">
            THE SNAP-BACK BLUEPRINT
          </h2>
          <p className="text-xl text-brand-charcoal/70 italic" data-id="element-100">
            The Accelerated Postpartum Body & Soul Restoration System.
          </p>
        </div>

        <div className="flex flex-col lg:flex-row gap-8 md:gap-12 items-center mb-12 md:mb-20" data-id="element-101">
          <div className="lg:w-1/2" data-id="element-102">
            <img src="https://cdn.magicpatterns.com/uploads/4xgp7gTaMLdbTvWAXVD1Eu/SNAPBACK_Bundle_Mock_Up.png" alt="The Snap-Back Blueprint Complete Bundle" className="w-full h-auto drop-shadow-2xl" data-id="element-103" />
          </div>

          <div className="lg:w-1/2" data-id="element-104">
            <p className="text-lg mb-8 leading-relaxed" data-id="element-105">
              This isn't just an eBook. It's a Hybrid Digital Experience that
              fits into the 15-minute "nap-time" window.
            </p>

            <div className="bg-brand-cream/40 p-6 rounded-2xl mb-8 border border-brand-gold/30" data-id="element-106">
              <h3 className="text-xl font-bold mb-2 flex items-start gap-3" data-id="element-107">
                <CheckCircle2 className="w-6 h-6 text-brand-sage shrink-0 mt-1" data-id="element-108" />
                <span data-id="element-109">THE SNAP-BACK BLUEPRINT (60-Page Main Guide)</span>
              </h3>
              <p className="text-brand-charcoal/80 ml-9" data-id="element-110">
                Your roadmap to hormonal balance and metabolic fire.
              </p>
            </div>

            <div className="space-y-6" data-id="element-111">
              {bonuses.map((bonus, idx) => <div key={idx} className="flex items-start gap-4" data-id="element-112">
                  <div className="bg-brand-gold/20 p-1 rounded-full shrink-0 mt-1" data-id="element-113">
                    <CheckCircle2 className="w-5 h-5 text-brand-gold" data-id="element-114" />
                  </div>
                  <div data-id="element-115">
                    <h4 className="font-bold text-lg" data-id="element-116">{bonus.title}</h4>
                    <p className="text-brand-charcoal/70" data-id="element-117">{bonus.desc}</p>
                  </div>
                </div>)}
            </div>
          </div>
        </div>

        <Testimonial imageSrc="https://cdn.magicpatterns.com/uploads/s61hQkdeRAANEK3pDk1ZbE/testimony_3.png" quote="I didn't just lose the 'mom-brain' fog. I found my spark. I was feeling 'touched-out' and invisible. The Identity Journal changed how I look at my reflection. My husband says I have a 'glow' back that he hasn't seen in years. I feel radiant, and for the first time, I'm proud of this skin." author="Amanda R., Miami, FL" result="Reclaimed confidence & intimacy." imagePosition="left" data-id="element-118" />
      </div>
    </section>;
}